import { createContext, useContext, useMemo, useReducer } from "react";
import { sportsDataHandlers, sportsDataInitialState, sportsDataReducer } from '../reducers/SportsDataReducer';
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { SportsDistrictContext } from "./SportsDistrictContext";
import { SportsSeasonContext } from "./SportsSeasonContext";

export const SportsDataContext = createContext()

export default function SportsDataProvider(props) {

  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const database_fns = _.get(parentContext, 'fns.database_fns')

  const { app_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sportPermissions } = sportsDistrict_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    gameScoringType,
    currentSeason_info,
    links_score,
    matches_info,
    teams_info,
    useScoringCollection,
    useScoringCollectionOnly,
  } = sportsSeason_state ?? {}

  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const init_state = {
    fn_cls,
    database_fns,
    sportPermissions,
    teams: teams_info && teams_info.teams,
    sportsKey,
    links_score,
    pathViews,
    latestSeason,
    gameScoringType,
    matches_info,
    useScoringCollection,
    useScoringCollectionOnly,
    mainDb
  }

  const [sportsData_state, sportsData_dispatch] = useReducer(sportsDataReducer, init_state, sportsDataInitialState)

  const sportsData_handlers = useMemo(
    () => sportsDataHandlers(sportsData_dispatch),
    [sportsData_dispatch]
  );

  return sportsData_state ?
    <SportsDataContext.Provider
      value={{ sportsData_state, sportsData_handlers, appComponent: 'sportsData' }}>
      {props.children}
    </SportsDataContext.Provider>
    :
    <div></div>
}